(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousal-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".dior-carousel-wrapper");
  const trigger = document.querySelector(".slide-trigger");

  if (wrapper && trigger) {
    trigger.addEventListener("click", () => {
      // Delay toggle until next frame to avoid layout jump
      requestAnimationFrame(() => {
        wrapper.classList.toggle("slide-products");
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Menu toggle functionality
  (function initializeMenuToggle() {
    function setupMenu() {
      const menuToggle = document.querySelector('.header__menu-toggle');
      const menuClose = document.querySelector('.header__menu-close');
      const inlineMenuClose = document.querySelector('.header__inline-menu-close');
      const fullMenu = document.querySelector('#header-full-menu');
      const body = document.body;

      if (!menuToggle || !menuClose || !inlineMenuClose || !fullMenu || !body) {
        console.error('Menu elements not found. Ensure the DOM contains .header__menu-toggle, .header__menu-close, .header__inline-menu-close, #header-full-menu, and body.');
        return;
      }

      // Toggle menu on hamburger button click
      menuToggle.addEventListener('click', (event) => {
        event.stopPropagation();
        console.log('Hamburger button clicked. Current menu state:', fullMenu.classList.contains('open'));
        if (fullMenu.classList.contains('open')) {
          fullMenu.classList.remove('open');
          body.classList.remove('menu-open');
          console.log('Menu closed');
        } else {
          fullMenu.classList.add('open');
          body.classList.add('menu-open');
          console.log('Menu opened');
        }
      });

      // Close menu with top-right close button
      menuClose.addEventListener('click', (event) => {
        event.stopPropagation();
        console.log('Top-right close button clicked');
        fullMenu.classList.remove('open');
        body.classList.remove('menu-open');
        console.log('Menu closed via top-right close button');
      });

      // Close menu with inline close button (X above Home)
      inlineMenuClose.addEventListener('click', (event) => {
        event.stopPropagation();
        console.log('Inline close button clicked');
        fullMenu.classList.remove('open');
        body.classList.remove('menu-open');
        console.log('Menu closed via inline close button');
      });

      // Close menu when clicking a link
      fullMenu.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', () => {
          console.log('Menu link clicked');
          fullMenu.classList.remove('open');
          body.classList.remove('menu-open');
          console.log('Menu closed via link click');
        });
      });
    }

    // Run immediately if DOM is already loaded, otherwise wait
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setupMenu();
    } else {
      window.addEventListener('DOMContentLoaded', setupMenu);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image_landscape"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      entry.target.classList.toggle('reveal', entry.isIntersecting);
    });
  }, { threshold: 0.25 });

  document.querySelectorAll('.lineup-slide').forEach(el => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();
})();
